(function () {

  if (window.innerWidth >= 768) return;

  const KEY_CLICKED = 'mobile_banner_clicked_forever';
  const KEY_CLOSED_UNTIL = 'mobile_banner_closed_until';

  const banner = document.querySelector('.mobile-app-banner');
  if (!banner) return;

  const closeBtn = banner.querySelector('[data-close]');
  const link = banner.querySelector('[data-banner-link]');
  link.href = generateSmartLink();
  
  
  const now = Date.now();

  if (localStorage.getItem(KEY_CLICKED)) return;

  const closedUntil = localStorage.getItem(KEY_CLOSED_UNTIL);
  if (closedUntil && now < Number(closedUntil)) return;


  banner.style.display = 'block';

  closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const sevenDays = 7 * 24 * 60 * 60 * 1000;
        localStorage.setItem(KEY_CLOSED_UNTIL, Date.now() + sevenDays);

        banner.remove();
  });
  
  function generateSmartLink() {
    //Initializing Smart Script arguments
    var oneLinkURL = "https://myflower.onelink.me/DiCa";
    var mediaSource = {keys:["utm_source"],defaultValue:"web_organic_banner"};
    var afSub2 = {keys:["googleClickIdKey"]};
    var afSub3 = {keys:["fbclid"]};
    var campaign = {keys:["utm_campaign"]};
    var afSub5 = {keys:["page_url"]};
    var afSub4 = {keys:["location"],defaultValue:"banner"};
    var gclid = {paramKey:"gclid",keys:["gclid"]};
    var gbraid = {paramKey:"gbraid",keys:["gbraid"]};
    var wbraid = {paramKey:"wbraid",keys:["wbraid"]};
    var custom_ss_ui = {paramKey:"af_ss_ui",defaultValue:"true"};

    //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
    //Onelink URL is generated.
    return window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL: oneLinkURL,
      afParameters: {
        mediaSource: mediaSource,
        afSub2: afSub2,
        afSub3: afSub3,
        campaign: campaign,
        afSub5: afSub5,
        afSub4: afSub4,
        afCustom: [
            gclid,
            gbraid,
            wbraid,
            custom_ss_ui
        ]
      }
    })?.clickURL;
  }
})();